"use strict";
/**
 * `Response` module: exports utilites to work with `Response` objects.
 *
 * @since 4.0.1
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Response|Response}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneResponse = void 0;
/**
 * Clones a `Response` object with the provided content as body.
 *
 * **Warning:** if the content is a plain object and _stringifying_ it fails, the cloned `Response`'s body will be set to `null` (the default value).
 *
 * @category helpers
 * @since 4.0.1
 */
var cloneResponse = function (from, content) {
    var body;
    try {
        body =
            typeof content === 'object' ? JSON.stringify(content) : String(content);
    }
    catch (e) {
        body = null;
    }
    return new Response(body, {
        headers: from.headers,
        status: from.status,
        statusText: from.statusText
    });
};
exports.cloneResponse = cloneResponse;
//# sourceMappingURL=response.js.map